<div class="relative flex w-[600px] max-w-[calc(100dvw-2rem)] flex-col justify-center overflow-hidden rounded-xl px-10 pb-10 pt-4">
  <h2>
    {{ 'chat.loadThreads.error.title' | transloco: { default: 'global.error.dialog.title' } }}
  </h2>


  <p>{{ 'chat.loadThreads.error.content' | transloco: { default: 'global.error.dialog.content' } }}</p>
  <p class="mt-2">
    {{ 'global.error.dialog.content2' | transloco }}
  </p>

  <p class="mt-2">
    <p-button (onClick)="reload()" >
      {{ 'global.error.dialog.reloadButton' | transloco }}
    </p-button>
  </p>
</div>